import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "In Need of Scoping",
description: "Limit which names are visible where by defining namespaces in Freon. This lesson shows how to restrict grading references to only the questions on the current page using a simple `.scope` file.",
tags: [ "Freon", "scoping", "namespaces", "scope rules", "Page", "questions", "grading", "DSL", "editor", "Education language", "tutorial"] ,
modifiedTime: "2025-11-07T17:20:18.626Z",
publishedTime: "2025-11-07T17:20:18.626Z"
    }
  };
};